import { Box } from 'components/Box/Box';
import { Button } from 'components/Button/Button';
import { Icon } from 'components/Icon/Icon';
import { LoadingDots } from 'components/LoadingDots/LoadingDots';

import {
  ContentLargeCTA,
  ContentLargeHeader,
  ContentLargeWrapper,
  DropBox,
} from './FilePicker.styled';
import { Filename } from './Filename';
import type { FilePickerProps } from './types';

type Props = Pick<
  FilePickerProps,
  | 'fileId'
  | 'showDate'
  | 'hideRemove'
  | 'downloadAttachment'
  | 'disabled'
  | 'onChange'
  | 'message'
  | 'header'
> & {
  qaId: string;
  onClick: () => void;
  filename?: string | null;
  created?: string | number | Date;
  loading?: boolean;
  onChange: (fileId?: string) => void;
};

export function ContentLarge({
  onClick,
  fileId,
  filename,
  qaId,
  hideRemove,
  onChange,
  loading,
  showDate,
  downloadAttachment,
  disabled,
  created,
  message,
  header,
  ...props
}: Props) {
  return (
    <Box width={1} flex="0 0 auto">
      <DropBox
        position="relative"
        onClick={onClick}
        $hasFile={Boolean(fileId)}
        $large
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      >
        <ContentLargeWrapper>
          {loading ? (
            <Box
              width={1}
              height={192}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <LoadingDots size="default" />
            </Box>
          ) : null}

          {!loading && fileId ? (
            <>
              <Box position="relative">
                <Icon name="paperclip" size={32} colorName="brandBlue" />
              </Box>
              <Box position="relative" ml={12} fontSize={[20, null, null, 24]}>
                <Filename
                  fileId={fileId}
                  filename={filename}
                  qaId={qaId}
                  hideRemove={hideRemove}
                  onChange={onChange}
                  created={showDate ? created : undefined}
                  downloadAttachment={downloadAttachment}
                  disabled={disabled}
                  large
                />
              </Box>
            </>
          ) : null}

          {!loading && !fileId ? (
            <ContentLargeCTA>
              {header ? (
                <ContentLargeHeader>{header}</ContentLargeHeader>
              ) : null}
              <Button
                type="inert"
                icon={{ type: 'normalized', name: 'paperclip' }}
                iconPosition="left"
                variant="primary"
              >
                {message}
              </Button>
            </ContentLargeCTA>
          ) : null}
        </ContentLargeWrapper>
      </DropBox>
    </Box>
  );
}
